import { Dispatch } from "react";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { UserLoyaltyProgramService } from "Bands/services";
import { USER_ACTIONS, IUserLoyaltyProgramPatchData } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { IStoreState } from "App/types";

export const dispatchGetUserLoyaltyPrograms = (dispatch: Dispatch<any>, userId?: string) => {
  dispatch(
    getUserLoyaltyPrograms({
      userId,
      page: 1,
      paginationKey: USER_ACTIONS.getUserLoyaltyPrograms,
    })
  );
};

const getUserLoyaltyPrograms = createAsyncThunk(
  USER_ACTIONS.getUserLoyaltyPrograms,
  async (
    { userId }: { userId?: string; page: number; paginationKey: string },
    { getState, rejectWithValue }
  ) => {
    try {
      const { currentUser } = (getState() as IStoreState).auth;

      const data = await UserLoyaltyProgramService.getUserLoyaltyPrograms({
        user: API_ENDPOINTS.USER(userId || currentUser?.id || ""),
      });

      return {
        [IDataKeys.userLoyaltyProgram]: data.userLoyaltyProgram,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUserLoyaltyProgram = createAsyncThunk(
  USER_ACTIONS.createUserLoyaltyProgram,
  async (program: IUserLoyaltyProgramPatchData, { rejectWithValue }) => {
    try {
      const data = await UserLoyaltyProgramService.createUserLoyaltyProgram(program);
      const id = Object.values(data?.userLoyaltyProgram)?.[0]?.attributes?.id;

      return { id, data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editUserLoyaltyProgram = createAsyncThunk(
  USER_ACTIONS.editUserLoyaltyProgram,
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: IUserLoyaltyProgramPatchData;
    },
    { rejectWithValue }
  ) => {
    try {
      return await UserLoyaltyProgramService.editUserLoyaltyProgram(id, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteUserLoyaltyProgram = createAsyncThunk(
  USER_ACTIONS.deleteUserLoyaltyProgram,
  async (id: string, { rejectWithValue }) => {
    try {
      await UserLoyaltyProgramService.deleteUserLoyaltyProgram(id);
      return {
        path: API_ENDPOINTS.USER_LOYALTY_PROGRAM(id),
        dataKey: IDataKeys.userLoyaltyProgram,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
